<template>
    <!--header开始-->
    <header class="site-header">
        <!-- 顶部白色区域 -->
        <div class="header-top">
            <div class="header-container">
                <div class="logo-area">
                    <router-link to="/" class="logo-link">
                        <img src="/static/images/logo.jpg" alt="山东省心理咨询行业协会" class="logo-img">
                    </router-link>
                </div>
                <div class="right-area">
                    <div class="search-box" :class="{ 'mobile-search-open': mobileSearchOpen }">
                        <input type="text" v-model="keyword" placeholder="请输入关键字" class="search-input"
                            @keyup.enter="search" />
                        <button class="search-btn" @click="search">
                            <svg viewBox="0 0 24 24" width="18" height="18" fill="white">
                                <path
                                    d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
                            </svg>
                        </button>
                    </div>
                    <button class="mobile-search-toggle" @click="toggleMobileSearch">
                        <svg viewBox="0 0 24 24" width="20" height="20" fill="#666">
                            <path
                                d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
                        </svg>
                    </button>
                    <div class="auth-links">
                        <a v-if="!isLogin" href="javascript:;" @click="showLogin" class="auth-link">登录/注册</a>
                        <router-link v-else to="/user/home" class="auth-link user-center">
                            <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" style="margin-right: 4px;">
                                <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                            </svg>
                            会员中心
                        </router-link>
                    </div>
                    <button class="mobile-menu-toggle" @click="toggleMobileMenu">
                        <span :class="{ 'active': mobileMenuOpen }"></span>
                        <span :class="{ 'active': mobileMenuOpen }"></span>
                        <span :class="{ 'active': mobileMenuOpen }"></span>
                    </button>
                </div>
            </div>
        </div>
        <!-- 底部蓝色导航栏 -->
        <div class="header-nav" :class="{ 'mobile-nav-open': mobileMenuOpen }" @click.self="closeMobileMenu">
            <div class="header-container">
                <div class="mobile-nav-header">
                    <div class="mobile-nav-title">菜单</div>
                    <button class="mobile-nav-close" @click="closeMobileMenu">
                        <svg viewBox="0 0 24 24" width="24" height="24" fill="#666">
                            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                        </svg>
                    </button>
                </div>
                <ul class="nav-list">
                    <li class="nav-item" v-for="(item, index) in navList" :key="index">
                        <router-link :to="item.url" :class="{ active: isActive(item.url) }" @click="closeMobileMenu">
                            {{ item.name }}
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
    </header>
    <!--header结束-->
</template>

<script>
import sys from "@/api/system";
import { mapGetters } from "vuex";

export default {
    name: "SiteHeader",
    computed: {
        ...mapGetters('auth', ['isLogin', 'account'])
    },
    data() {
        return {
            keyword: '',
            mobileMenuOpen: false,
            mobileSearchOpen: false,
            navList: []
        }
    },
    created() {
        this.getNavMainList();
    },
    methods: {
        getNavMainList() {
            sys.getNavMainList({
                type: 'pc'
            }).then(res => {
                if (res && res.data && res.data.length > 0) {
                    this.navList = res.data;
                }
            }).catch(() => {
                // 使用默认导航
            })
        },
        search() {
            if (this.keyword.trim()) {
                this.$store.commit("updateKeyword", this.keyword);
                this.$router.push('/search');
                this.mobileSearchOpen = false;
            }
        },
        isActive(url) {
            if (url === '/') {
                return this.$route.path === '/';
            }
            return this.$route.path.startsWith(url);
        },
        showLogin() {
            this.$store.dispatch('toggleLoginModal');
        },
        logout() {
            this.$store.dispatch('clearAccount');
            this.$message.success('退出成功');
            this.$router.push('/');
        },
        toggleMobileMenu() {
            this.mobileMenuOpen = !this.mobileMenuOpen;
            if (this.mobileMenuOpen) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = '';
            }
        },
        closeMobileMenu() {
            this.mobileMenuOpen = false;
            document.body.style.overflow = '';
        },
        toggleMobileSearch() {
            this.mobileSearchOpen = !this.mobileSearchOpen;
        }
    },
    beforeUnmount() {
        document.body.style.overflow = '';
    }
}
</script>

<style lang="scss" scoped>
.site-header {
    width: 100%;
    position: relative;
    z-index: 100;
}

.header-top {
    background: #fff;
    padding: 10px 0;
    position: relative;
}

.header-container {
    width: 1400px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.logo-area {
    .logo-link {
        display: flex;
        align-items: center;
        text-decoration: none;
    }

    .logo-img {
        margin-right: 12px;
    }

    .logo-text {
        .site-name {
            font-size: 22px;
            font-weight: bold;
            color: #333;
            margin: 0 0 4px 0;
            letter-spacing: 1px;
        }

        .site-name-en {
            font-size: 11px;
            color: #999;
            margin: 0;
            letter-spacing: 0.5px;
            text-transform: uppercase;
        }
    }
}

.right-area {
    display: flex;
    align-items: center;
    gap: 60px;
}

.auth-links {
    display: flex;
    align-items: center;
    gap: 6px;

    .auth-link {
        color: #666;
        font-size: 14px;
        text-decoration: none;
        cursor: pointer;

        &:hover {
            color: #1e9dd4;
        }

        &.user-center {
            display: flex;
            align-items: center;
            font-weight: 500;
        }
    }

    .separator {
        color: #ccc;
        font-size: 12px;
    }
}

.search-box {
    display: flex;
    align-items: center;
    border: 1px solid #ddd;
    border-radius: 3px;
    overflow: hidden;
    background: #fff;
    width: 400px;

    .search-input {
        flex: 1;
        height: 40px;
        padding: 0 15px;
        border: none;
        outline: none;
        font-size: 14px;
        color: #666;

        &::placeholder {
            color: #aaa;
        }
    }

    .search-btn {
        width: 60px;
        height: 40px;
        background: #1e9dd4;
        border: none;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;

        svg {
            display: block;
        }

        &:hover {
            background: #1789bd;
        }
    }
}

.header-nav {
    background: #1e9dd4;

    .header-container {
        justify-content: flex-start;
    }
}

.nav-list {
    display: flex;
    align-items: center;
    list-style: none;
    margin: 0;
    padding: 0;

    .nav-item {
        position: relative;

        a {
            display: block;
            padding: 20px 30px;
            color: #fff;
            font-size: 18px;
            text-decoration: none;
            transition: all 0.3s;
            white-space: nowrap;

            &:hover,
            &.active {
                background: rgba(255, 255, 255, 0.2);
            }
        }
    }
}

.mobile-menu-toggle {
    display: none;
    flex-direction: column;
    justify-content: space-around;
    width: 28px;
    height: 24px;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    z-index: 10;

    span {
        width: 100%;
        height: 3px;
        background: #333;
        border-radius: 2px;
        transition: all 0.3s ease;
        transform-origin: center;

        &.active:nth-child(1) {
            transform: translateY(10.5px) rotate(45deg);
        }

        &.active:nth-child(2) {
            opacity: 0;
        }

        &.active:nth-child(3) {
            transform: translateY(-10.5px) rotate(-45deg);
        }
    }
}

.mobile-search-toggle {
    display: none;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 5px;
    align-items: center;
    justify-content: center;

    &:hover {
        opacity: 0.7;
    }
}

.mobile-nav-header {
    display: none;
}

@media screen and (max-width: 1240px) {
    .header-container {
        width: 100%;
        padding: 0 20px;
        box-sizing: border-box;
    }

    .nav-list .nav-item a {
        padding: 12px 16px;
        font-size: 14px;
    }
}

@media screen and (max-width: 992px) {
    .header-top {
        padding: 10px 0;
    }

    .logo-area {
        .logo-img {
            max-width: 180px;
            height: auto;
        }

        .logo-text .site-name {
            font-size: 18px;
        }

        .logo-text .site-name-en {
            font-size: 10px;
        }
    }

    .right-area {
        gap: 15px;
    }

    .search-box {
        width: 250px;

        .search-input {
            font-size: 13px;
        }
    }

    .nav-list .nav-item a {
        padding: 10px 12px;
        font-size: 13px;
    }
}

@media screen and (max-width: 768px) {
    .header-top {
        padding: 12px 0;
    }

    .header-container {
        padding: 0 15px;
    }

    .logo-area {
        .logo-img {
            max-width: 150px;
        }
    }

    .right-area {
        gap: 10px;
    }

    .search-box {
        display: none;
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        width: 100%;
        border: none;
        border-top: 1px solid #ddd;
        border-radius: 0;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        z-index: 10;

        &.mobile-search-open {
            display: flex;
        }

        .search-input {
            height: 45px;
            font-size: 14px;
        }

        .search-btn {
            height: 45px;
            width: 60px;
        }
    }

    .mobile-search-toggle {
        display: flex;
    }

    .auth-links {
        font-size: 13px;

        .auth-link {
            font-size: 13px;
        }
    }

    .mobile-menu-toggle {
        display: flex;
    }

    .header-nav {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: transparent;
        visibility: hidden;
        z-index: 999;

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.5);
            opacity: 0;
            transition: opacity 0.3s ease;
        }

        &.mobile-nav-open {
            visibility: visible;

            &::before {
                opacity: 1;
            }
        }

        .header-container {
            position: absolute;
            left: 0;
            top: 0;
            width: 75%;
            max-width: 320px;
            height: 100%;
            background: #fff;
            padding: 0;
            overflow-y: auto;
            transform: translateX(-100%);
            transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            box-shadow: 2px 0 12px rgba(0, 0, 0, 0.15);
            display: flex;
            flex-direction: column;
        }

        &.mobile-nav-open .header-container {
            transform: translateX(0);
        }
    }

    .mobile-nav-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px 20px;
        border-bottom: 1px solid #e8e8e8;
        background: #fafafa;

        .mobile-nav-title {
            font-size: 16px;
            font-weight: 600;
            color: #333;
        }

        .mobile-nav-close {
            background: transparent;
            border: none;
            cursor: pointer;
            padding: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            transition: background 0.2s ease;

            &:active {
                background: #e8e8e8;
            }
        }
    }

    .nav-list {
        flex-direction: column;
        align-items: stretch;
        padding: 20px 0;

        .nav-item {
            width: 100%;
            opacity: 0;
            transform: translateX(-20px);
            transition: opacity 0.3s ease, transform 0.3s ease;

            &:not(:last-child) {
                border-bottom: 1px solid #f0f0f0;
            }

            a {
                padding: 16px 24px;
                font-size: 16px;
                color: #333;
                background: transparent;
                position: relative;
                font-weight: 500;
                transition: all 0.2s ease;

                &::before {
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 4px;
                    height: 0;
                    background: #1e9dd4;
                    transition: height 0.2s ease;
                    border-radius: 0 2px 2px 0;
                }

                &:active {
                    background: #f8f8f8;
                }

                &:hover,
                &.active {
                    background: #f5f9fc;
                    color: #1e9dd4;
                    padding-left: 28px;

                    &::before {
                        height: 24px;
                    }
                }
            }
        }
    }

    .mobile-nav-open .nav-list .nav-item {
        opacity: 1;
        transform: translateX(0);

        @for $i from 1 through 10 {
            &:nth-child(#{$i}) {
                transition-delay: #{0.05 + $i * 0.03}s;
            }
        }
    }
}

@media screen and (max-width: 480px) {
    .header-container {
        padding: 0 12px;
    }

    .logo-area {
        .logo-img {
            max-width: 120px;
        }
    }

    .right-area {
        gap: 8px;
    }

    .auth-links {
        .auth-link {
            font-size: 12px;
        }

        .separator {
            font-size: 11px;
        }
    }

    .mobile-menu-toggle {
        width: 24px;
        height: 20px;

        span {
            height: 2.5px;

            &.active:nth-child(1) {
                transform: translateY(8.75px) rotate(45deg);
            }

            &.active:nth-child(3) {
                transform: translateY(-8.75px) rotate(-45deg);
            }
        }
    }

    .header-nav {
        .header-container {
            width: 80%;
            max-width: 280px;
        }
    }

    .nav-list {
        padding: 15px 0;

        .nav-item a {
            padding: 14px 20px;
            font-size: 15px;
        }
    }
}
</style>
